import { Menu, MenuItem, styled } from "@mui/material";
import embedIcon from "../../icons/embed_desktop.svg";
import linkIcon from "../../icons/link_desktop.svg";
import RedditIcon from "../../icons/reddit_desktop.svg";
import TwitterIcon from "../../icons/twitter_desktop.svg";
import DiscordIcon from "../../icons/discord_desktop.svg";
import { Fragment, MouseEvent } from "react";
import { ICollection, IGif } from "services/types";
import classes from "./MorePopup/MorePopup.module.css";
import { RedditShareButton, TwitterShareButton } from "react-share";
import { useDispatch } from "react-redux";
import { setServerResponse } from "store/application/application-action";
import { getSharedLink } from "../../../utils/share";

interface IProps {
  anchorEl: null | HTMLElement;
  gif?: IGif;
  collection?: ICollection;
  handleEmbedPopup: () => void;
  handleClose: (event: MouseEvent) => void;
}

const ShareDropdownMenu = (props: IProps) => {
  const { gif, collection, handleEmbedPopup, anchorEl, handleClose } = props;
  const isOpen = Boolean(anchorEl);

  const dispatch = useDispatch();

  const handleCopyLinkButton = (event: MouseEvent) => {
    if (gif) {
      navigator.clipboard.writeText(getSharedLink("gif", gif));
    } else if (collection) {
      navigator.clipboard.writeText(getSharedLink("collection", collection));
    }

    dispatch(setServerResponse("Link copied!"));
    handleClose(event);
  };

  const handleEmbed = (event: MouseEvent) => {
    handleEmbedPopup();
    handleClose(event);
  };

  const ACTIONS = [
    { text: "Copy Link", icon: linkIcon, onClick: handleCopyLinkButton },
    { text: "Embed", icon: embedIcon, onClick: handleEmbed },
    { text: "Reddit", icon: RedditIcon, onClick: () => "Idle" },
    { text: "Twitter", icon: TwitterIcon, onClick: () => "Idle" },
    { text: "Discord", icon: DiscordIcon, onClick: handleCopyLinkButton },
  ];

  return (
    <Menu
      anchorEl={anchorEl}
      open={isOpen}
      onClose={handleClose}
      classes={{ paper: classes.menuList }}
      anchorOrigin={{
        vertical: "center",
        horizontal: "right",
      }}
      transformOrigin={{
        vertical: "center",
        horizontal: "left",
      }}
    >
      {ACTIONS.map((el, index) => (
        <div key={index}>
          {index === 2 && (
            <p style={{
              fontSize: "12px",
              color: "#1D1D1D",
              opacity: 0.5,
              marginLeft: "1rem",
              marginTop: "14px",
              marginBottom: "4px"
            }}>Social share:</p>
          )}
          {el.text === "Embed" && collection ? null : (
            <MenuItem
              onClick={el.onClick}
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "8px"
              }}
            >
              {el.text === "Reddit" ? (
                <RedditShareButton
                  url={collection ? getSharedLink("collection", collection) : getSharedLink("gif", gif)}
                  style={{ width: "100%" }}
                >
                  <SharingButtonContainer>
                    <img src={RedditIcon} alt="Reddit"/>
                    <ShareButtonLabel>Reddit</ShareButtonLabel>
                  </SharingButtonContainer>
                </RedditShareButton>
              ) : el.text === "Twitter" ? (
                <TwitterShareButton
                  url={collection ? getSharedLink("collection", collection) : getSharedLink("gif", gif)}
                  style={{ width: "100%" }}
                >
                  <SharingButtonContainer>
                    <img src={TwitterIcon} alt="Twitter"/>
                    <ShareButtonLabel>Twitter</ShareButtonLabel>
                  </SharingButtonContainer>
                </TwitterShareButton>
              ) : (
                <Fragment>
                  <img src={el.icon} alt={el.text}/>
                  <ShareButtonLabel>{el.text}</ShareButtonLabel>
                </Fragment>
              )}
            </MenuItem>
          )}
        </div>
      ))}
    </Menu>
  );
};

const ShareButtonLabel = styled("p")({
  fontSize: "12px",
  fontFamily: "Poppins",
  fontWeight: 500,
  cursor: "pointer"
});

const SharingButtonContainer = styled("div")({
  display: "flex",
  alignItems: "center",
  gap: "8px",
  cursor: "pointer"
});

export default ShareDropdownMenu;
